import esLocale from '@fullcalendar/core/locales/es';
import frLocale from '@fullcalendar/core/locales/fr';
import enGbLocale from '@fullcalendar/core/locales/en-gb';
import itLocale from '@fullcalendar/core/locales/it';
import deLocale from '@fullcalendar/core/locales/de';

export const calendarLocales = [
  esLocale,
  frLocale,
  enGbLocale,
  itLocale,
  deLocale,
];
